var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRekkevidde = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18.099 4.8c-.1-.5-.5-.8-1-.8h-4.1l.2 3h-2.4l.2-3h-4.2c-.5 0-.9.4-1 .8l-2.7 14c-.1.6.4 1.2 1 1.2h5.9l.3-5h3.4l.3 5h5.8c.6 0 1.1-.6 1-1.2l-2.7-14Zm-7.7 8.2.2-4h2.6l.2 4h-3Z",
  fill: "#267C4F"
})));
export default SvgRekkevidde;